export const HOME_SCHEMA = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@id': 'https://everest.ind.br/#organization',
			'@type': 'Organization',
			name: 'Everest',
			url: 'https://everest.ind.br/',
			logo: {
				'@type': 'ImageObject',
				url: 'https://everest.ind.br/assets/images/logo-slogan.png',
			},
			email: 'contato@everest.ind.br',
			contactPoint: {
				'@type': 'ContactPoint',
				telephone: '0800-024-0332',
				contactType: 'customer service',
				availableLanguage: 'Portuguese',
				hoursAvailable: {
					'@type': 'OpeningHoursSpecification',
					dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
					opens: '08:30',
					closes: '17:30',
				},
				contactOption: 'TollFree',
				areaServed: 'BR',
			},
			sameAs: [
				'https://www.instagram.com/everestoficial_/',
				'https://www.linkedin.com/company/everestoficial/',
				'https://www.facebook.com/everestoficialbr',
				'https://www.youtube.com/@everestoficial_',
				'https://www.tiktok.com/@everest_br',
			],
		},
		{
			'@type': 'WebSite',
			'@id': 'https://everest.ind.br/#website',
			name: 'Everest',
			url: 'https://everest.ind.br/',
			inLanguage: 'pt-BR',
			publisher: {
				'@id': 'https://everest.ind.br/#organization',
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://everest.ind.br/#product-list',
			name: 'Produtos Everest',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					item: {
						name: 'Everest Star',
						url: 'https://everest.ind.br/pt/produto/everest-star',
					},
				},
				{
					'@type': 'ListItem',
					position: 2,
					item: {
						name: 'Everest Slim',
						url: 'https://everest.ind.br/pt/produto/everest-slim',
					},
				},
				{
					'@type': 'ListItem',
					position: 3,
					item: {
						name: 'Everest Fit',
						url: 'https://everest.ind.br/pt/produto/everest-fit',
					},
				},
				{
					'@type': 'ListItem',
					position: 4,
					item: {
						name: 'Everest Plus',
						url: 'https://everest.ind.br/pt/produto/everest-plus',
					},
				},
				{
					'@type': 'ListItem',
					position: 5,
					item: {
						name: 'Everest Baby',
						url: 'https://everest.ind.br/pt/produto/everest-baby',
					},
				},
				{
					'@type': 'ListItem',
					position: 6,
					item: {
						name: 'Refil Original Everest',
						url: 'https://everest.ind.br/pt/produto/refil-original-everest',
						description:
							'Refil compatível com modelos Everest Baby, Fit, Slim, Star e Plus, utilizado para retenção de impurezas e redução de cloro na água e com vida útil de 4.000 litros.',
					},
				},
			],
		},
		{
			'@type': 'WebPage',
			'@id': 'https://everest.ind.br/#webpage',
			name: 'Everest | Sua escolha em Purificadores e Máquinas de Gelo',
			url: 'https://everest.ind.br/',
			description:
				'Conheça e aposte nos purificadores de água gelada e máquinas de gelo da Everest.',
			inLanguage: 'pt-BR',
			isPartOf: {
				'@id': 'https://everest.ind.br/#website',
			},
			publisher: {
				'@id': 'https://everest.ind.br/#organization',
			},
			mainEntity: {
				'@id': 'https://everest.ind.br/#product-list',
			},
		},
	],
}
